import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../i18nContext';
import { api, absoluteUrl } from '../../lib/api';

// Embeddable "Consejo Directivo" section — president intro + dynamic board
// members grid (from /board-members) + president quote. Rendered both on the
// public board page and as the `board_members` CMS block (WYSIWYG embed).
export default function BoardSection() {
  const t = useTranslation();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get('/board-members')
      .then(({ data }) => { if (alive) setMembers(data || []); })
      .catch(() => { if (alive) setMembers([]); });
    return () => { alive = false; };
  }, []);

  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="consejo-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-charcoal-800 mb-6">{t.about.presTitle}</h2>
          <div className="space-y-4 text-charcoal-600 text-lg leading-relaxed">
            <p>{t.about.presP1}</p>
            <p>{t.about.presP2}</p>
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-sm font-semibold text-cmic-600 uppercase tracking-wider mb-8">{t.about.boardTitle}</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {members.map((m, i) => (
              <div key={m.id || i} className="group text-center" data-testid={`board-member-${i}`}>
                {m.photo_url && (
                  <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden ring-4 ring-charcoal-100 group-hover:ring-cmic-200 transition-all duration-300 shadow-lg bg-cmic-100">
                    <img src={absoluteUrl(m.photo_url)} alt={m.name} className="w-full h-full object-cover"
                      onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                )}
                <p className="text-charcoal-800 font-semibold">{m.name}</p>
                <p className="text-sm text-cmic-600 font-medium uppercase tracking-wider mt-1">{m.role}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-br from-cmic-800 to-cmic-700 rounded-2xl p-8 sm:p-10 text-white">
          <p className="text-cmic-100 italic text-lg leading-relaxed mb-6">{t.about.presQuote}</p>
          <div className="border-t border-white/20 pt-6">
            <p className="font-semibold text-white">{t.about.presName}</p>
            <p className="text-sm text-cmic-300">{t.about.presRole}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
